import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from '../NavMenu';
import Sidebar from "../Shared/Sidebar";
import Footer1 from "../Shared/Footer1";
//import "../../Assets/Styles/Layout.css";
/*import UserLogin from "../Account/UserLogin";*/
export class Layout extends Component {
  static displayName = Layout.name;
  render() {
    return (
      //<div>
      //  {/*<NavMenu />*/}
      //  <Sidebar/>
      // {/* <UserLogin/>*/}
      //  <Container>
      //    {this.props.children}
      //  </Container>
      //      <p>&nbsp;</p>
      //      {/*<p>&nbsp;</p>*/}
      //      {/*<p>&nbsp;</p>*/}
      //      <Footer1 />

      //  </div>

    <div className="app-layout">
     <Sidebar/>
       <Container className="content">
          {this.props.children}
      </Container>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
      <Footer1 />
    </div>
    );
  }
}
